import GoogleTagManager from '@redux-beacon/google-tag-manager'
import { applyMiddleware, compose, createStore as reduxCreateStore } from 'redux'
import { createMiddleware } from 'redux-beacon'
import { createEpicMiddleware, type Epic } from 'redux-observable'
import thunk from 'redux-thunk'

import type { ApisType } from '@/legacy-src/store/createApis'

import GTMMiddleware from '../analytics/GTMMiddleware'
import FetchingMiddleware from '../services/FetchingMiddleware'
import makeRootReducer from './reducers'

const gtm = GoogleTagManager()

export type CreateStoreState = Record<string, unknown>
export type CreateStoreOptions = {
  initialState: CreateStoreState
  isServer: boolean
  apis: ApisType
  rootEpic: Epic
}

export const createStore = ({ isServer, initialState = {}, apis, rootEpic }: CreateStoreOptions) => {
  const epicMiddleware = createEpicMiddleware()

  const composeEnhancers =
    (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose
  const middleware = [thunk, FetchingMiddleware, epicMiddleware]
  const enhancers: [] = []

  middleware.push(createMiddleware(GTMMiddleware, gtm))

  const store = reduxCreateStore(
    // @ts-expect-error redux will never be typed correctly. We will ditch it
    makeRootReducer(isServer),
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers),
  )

  apis.connect(store.getState, store.dispatch)

  // @ts-expect-error redux will never be typed correctly. We will ditch it
  store.asyncReducers = {}

  epicMiddleware.run(rootEpic)

  return store
}

export type CreateStore = typeof createStore
